module.exports = "/_next/static/images/footer-logo-white-1ee1930793df47027c56279517ae496d.png";